enum PlanLength {
    ThreeMonths = "THREE_MONTHS",
    SixMonths = "SIX_MONTHS",
    TwelveMonths = "TWELVE_MONTHS",
}
export default PlanLength